import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a4b1dfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-0 d-flex w-100" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "dropdown-menu-divider"
}
const _hoisted_4 = {
  key: 1,
  id: "container-dropdown-menu",
  class: "position-absolute w-100 p-5 bg-white rounded-bottom f-12"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "fw-semibold f-14 text-w-primary" }
const _hoisted_10 = {
  key: 2,
  id: "zonesDesktop",
  ref: "zones",
  class: "map-autocomplete f-14 line-height-base line-height-small"
}
const _hoisted_11 = {
  key: 0,
  class: "dropdown-menu-divider"
}
const _hoisted_12 = { class: "ms-20" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["data-place-id", "data-url", "title"]
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "accordion-item" }
const _hoisted_17 = { class: "d-flex justify-content-between w-100" }
const _hoisted_18 = ["data-bs-target", "aria-controls"]
const _hoisted_19 = ["id", "aria-labelledby"]
const _hoisted_20 = { class: "accordion-body" }
const _hoisted_21 = {
  key: 1,
  class: "px-20 py-10"
}
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["data-place-id", "data-url", "title"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["src"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_autocomplete = _resolveComponent("base-autocomplete")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_checkbox_btn = _resolveComponent("checkbox-btn")!
  const _component_radio_button = _resolveComponent("radio-button")!
  const _component_static_spinner = _resolveComponent("static-spinner")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "input-container",
      ref: "placeBoxContainer",
      class: _normalizeClass(["container-search-box w-100 position-relative", _ctx.containerClasses])
    }, [
      (_ctx.valuation)
        ? (_openBlock(), _createBlock(_component_base_autocomplete, {
            key: 0,
            id: "valuation-autocomplete",
            theme: "bordered",
            "model-value": _ctx.valuationAddress,
            placeholder: _ctx.labels.enter_a_address,
            "on-input-change-cb": _ctx.onInputChangeCb,
            "on-option-selected-cb": _ctx.optionSelectedCb,
            "disable-cb": _ctx.disableCb,
            border: false,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick())),
            onChangedValue: _cache[1] || (_cache[1] = v => _ctx.valuationAddress = v)
          }, null, 8 /* PROPS */, ["model-value", "placeholder", "on-input-change-cb", "on-option-selected-cb", "disable-cb"]))
        : (_ctx.freesearch)
          ? (_openBlock(), _createBlock(_component_base_input, {
              key: 1,
              id: "freesearch-input",
              modelValue: _ctx.freesearchValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.freesearchValue) = $event)),
              "input-class": "mt-5",
              class: "pt-10",
              placeholder: _ctx.labels.place,
              autocomplete: "none",
              onKeydownEnterPressed: _ctx.confirmPlace
            }, null, 8 /* PROPS */, ["modelValue", "placeholder", "onKeydownEnterPressed"]))
          : (_openBlock(), _createBlock(_component_base_autocomplete, {
              key: 2,
              id: "place-ac",
              ref: "placeAutocomplete",
              "data-cy": "place-ac",
              border: _ctx.listing,
              class: _normalizeClass([
          {'show-zones': _ctx.showZoneModal},
          {'dropdown-menu-shown': _ctx.dropDownMenu}
        ]),
              "on-input-change-cb": _ctx.getPlaceFn,
              theme: _ctx.listing ? 'all-bordered' : 'bordered',
              placeholder: _ctx.placeholder,
              "model-value": _ctx.autocompleteValue,
              "disable-cb": _ctx.disableCb,
              "manual-close": _ctx.dropDownMenu,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = e => _ctx.managePlace(e.payload)),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClick())),
              onChangedValue: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dropDownMenu = false))
            }, {
              lefticon: _withCtx(() => [
                _createElementVNode("img", {
                  src: `${_ctx.cdn}/_ui/img/Ico/zoom-blue.svg`,
                  alt: "cerca",
                  class: "text-input-icon left sm",
                  width: "16",
                  height: "16"
                }, null, 8 /* PROPS */, _hoisted_2)
              ]),
              righticon: _withCtx(() => []),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["border", "class", "on-input-change-cb", "theme", "placeholder", "model-value", "disable-cb", "manual-close"])),
      (_ctx.showPlaceMapDropDown)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createCommentVNode(" DROPDOWN MENU: PLACE + MAP "),
            (!_ctx.listing && _ctx.dropDownMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3))
              : _createCommentVNode("v-if", true),
            (_ctx.dropDownMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createCommentVNode(" DROPDOWN PLACE "),
                  (_ctx.isSearchReady)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "popup-search-text",
                        class: "rounded-5 p-10 pointer mb-5",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fromDropDownToZoneModal && _ctx.fromDropDownToZoneModal(...args)), ["stop"]))
                      }, [
                        _createElementVNode("img", {
                          class: "icon me-5",
                          width: "20",
                          height: "20",
                          src: `${_ctx.cdn}/_ui/img/Icons/Pin-gs.svg`,
                          alt: "icona Pin"
                        }, null, 8 /* PROPS */, _hoisted_5),
                        (!!_ctx.searchBean.polygonFromMap)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.labels.insertSearchCity), 1 /* TEXT */))
                          : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.labels.editCity), 1 /* TEXT */))
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" DROPDOWN MAP "),
                  _createElementVNode("div", {
                    id: "popup-search-map",
                    class: "d-flex align-items-center rounded-5 p-10 pointer",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openMapDraw()))
                  }, [
                    _createElementVNode("img", {
                      class: "icon me-10",
                      width: "16",
                      height: "16",
                      src: `${_ctx.cdn}/_ui/img/Ico/touch.svg`,
                      alt: "icona mappa"
                    }, null, 8 /* PROPS */, _hoisted_8),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.labels.drawOnMap), 1 /* TEXT */)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" CONTAINER ZONELIST "),
            (!_ctx.areZonesAndLocalitiesEmpty() && _ctx.showZoneModal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (!_ctx.listing)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("ul", {
                    id: "zone-list-desktop",
                    class: _normalizeClass(["w-100 list-unstyled position-absolute rounded-bottom overflow-y-auto-hidden bg-white border border-w-cultured form-control-menu-multiple d-block rounded-bottom", {'listing': _ctx.listing}]),
                    style: {"max-height":"250px","box-shadow":"0 3px 3px rgba(27, 27, 27, 0.1)","z-index":"1006"},
                    tabindex: "0",
                    onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("li", _hoisted_12, [
                      _createVNode(_component_checkbox_btn, {
                        id: "wholeMunicipality",
                        class: "d-flex align-items-center",
                        "input-class": "flex-shrink-0",
                        "data-cy": "wholeMunicipality",
                        label: _ctx.labels.wholeMunicipality,
                        checked: !_ctx.isZoneOrLocalitySelected() && !(Object.keys(_ctx.districtSelected).length > 0),
                        onChange: _cache[8] || (_cache[8] = ($event: any) => {_ctx.resetSearchBeanZonesAndLocalities(); _ctx.showZoneModal=false; _ctx.confirmPlace();})
                      }, null, 8 /* PROPS */, ["label", "checked"])
                    ]),
                    (_ctx.areZonesAndLocalitiesFilled())
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: "select-group places-li-label",
                          innerHTML: _ctx.zonesLabel
                        }, null, 8 /* PROPS */, _hoisted_13))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoneList, (zone) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: zone.zoneID,
                        class: "flex-column line-height-small",
                        "data-place-id": zone.placeID,
                        "data-url": zone.zoneURL,
                        title: zone.zoneName
                      }, [
                        (zone.subPlaces.length>0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              id: 'accordionWrapper_'+zone.zoneID,
                              class: "accordion",
                              onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent","stop"]))
                            }, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_component_checkbox_btn, {
                                    id: 'checkbox_' + zone.zoneID,
                                    "data-id": 'checkbox_' + zone.zoneID,
                                    class: "d-inline-flex align-items-center ms-20 w-100",
                                    "input-class": "flex-shrink-0",
                                    label: zone.zoneName,
                                    "container-id": 'accordionWrapper_'+zone.zoneID,
                                    checked: _ctx.isZoneSelected(zone.zoneID),
                                    onChange: ($event: any) => {_ctx.onPlaceLIClick(zone, _ctx.updatePlaceNameAndEmit);}
                                  }, null, 8 /* PROPS */, ["id", "data-id", "label", "container-id", "checked", "onChange"]),
                                  _createElementVNode("button", {
                                    class: "accordion-button w-auto collapsed d-inline-flex",
                                    type: "button",
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": '#accordioItem_'+zone.zoneID,
                                    "aria-expanded": "true",
                                    "aria-controls": '#accordioItem_'+zone.zoneID
                                  }, null, 8 /* PROPS */, _hoisted_18)
                                ]),
                                _createElementVNode("div", {
                                  id: 'accordioItem_'+zone.zoneID,
                                  class: "accordion-collapse collapse",
                                  "aria-labelledby": 'accordioHeader_'+zone.zoneID
                                }, [
                                  _createElementVNode("div", _hoisted_20, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zone.subPlaces, (district) => {
                                      return (_openBlock(), _createBlock(_component_checkbox_btn, {
                                        id: district.districtID,
                                        key: district.districtID,
                                        "input-class": "flex-shrink-0",
                                        "data-cy": `district_${district.districtID}`,
                                        label: district.districtName,
                                        checked: _ctx.isDistrictSelected(district.zoneID,district.districtID) || _ctx.areAllDistrictsSelected(zone.zoneID),
                                        onChange: ($event: any) => {_ctx.onDistrictClick(zone,district,_ctx.updatePlaceNameAndEmit);}
                                      }, null, 8 /* PROPS */, ["id", "data-cy", "label", "checked", "onChange"]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ], 8 /* PROPS */, _hoisted_19)
                              ])
                            ], 8 /* PROPS */, _hoisted_15))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createVNode(_component_checkbox_btn, {
                                id: 'checkbox_' + zone.zoneID,
                                "data-id": 'checkbox_' + zone.zoneID,
                                "wrapper-margin-y": "my-0",
                                label: zone.zoneName,
                                class: "d-flex align-items-center",
                                "input-class": "flex-shrink-0",
                                "container-id": 'accordionWrapper_'+zone.zoneID,
                                "label-class": "w-100",
                                checked: _ctx.isZoneSelected(zone.zoneID),
                                onChange: ($event: any) => {_ctx.onPlaceLIClick(zone, _ctx.updatePlaceNameAndEmit);}
                              }, null, 8 /* PROPS */, ["id", "data-id", "label", "container-id", "checked", "onChange"])
                            ]))
                      ], 8 /* PROPS */, _hoisted_14))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (_ctx.localityList.length)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 1,
                          class: "places-li-label",
                          innerHTML: _ctx.localitiesLabel
                        }, null, 8 /* PROPS */, _hoisted_22))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localityList, (locality) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: locality.localityID,
                        "data-element": "",
                        "data-place-id": locality.placeID,
                        "data-url": locality.zoneURL,
                        title: locality.localityName
                      }, [
                        _createVNode(_component_radio_button, {
                          class: "mx-20 py-10 d-flex align-items-center",
                          "label-classes": "ps-10",
                          label: locality.localityName,
                          "is-checked": _ctx.isLocationSelected(locality.localityID),
                          onChange: ($event: any) => (_ctx.onPlaceLIClick(locality, _ctx.updatePlaceNameAndEmit, true))
                        }, null, 8 /* PROPS */, ["label", "is-checked", "onChange"])
                      ], 8 /* PROPS */, _hoisted_23))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 2 /* CLASS */)
                ], 512 /* NEED_PATCH */))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" FREESEARCH DESKTOP "),
      (_ctx.freesearch)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _createVNode(_component_base_button, {
              id: "freesearch-btn",
              "is-loading": _ctx.spinnerIcon,
              "btn-class": `btn-transparent d-none d-sm-block position-absolute top-5px end-0 text-w-primary ${_ctx.spinnerIcon ? 'p-0' : ''}`,
              onClick: _ctx.confirmPlace
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: _ctx.labels.genericSearch
                }, null, 8 /* PROPS */, _hoisted_24)
              ]),
              spinner: _withCtx(() => [
                _createVNode(_component_static_spinner, { class: "me-10 border-none rounded bg-w-secondary icon-xxl" })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-loading", "btn-class", "onClick"]),
            _createCommentVNode(" FREESEARCH MOBILE "),
            _createVNode(_component_base_button, {
              "btn-class": "btn-w-primary d-sm-none position-absolute top-5px end-0 d-flex align-items-center",
              "is-loading": _ctx.spinnerIcon,
              onClick: _ctx.confirmPlace
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "icon",
                  width: "20",
                  height: "20",
                  src: `${_ctx.cdn}/_ui/img/Ico/search-white.svg`,
                  alt: "icona Pin"
                }, null, 8 /* PROPS */, _hoisted_25)
              ]),
              spinner: _withCtx(() => [
                _createVNode(_component_static_spinner, { class: "icon-md" })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-loading", "onClick"])
          ], 64 /* STABLE_FRAGMENT */))
        : ((_ctx.listing && !_ctx.dropDownMenu && !_ctx.showZoneModal && !_ctx.spinnerIcon && !_ctx.valuation && _ctx.placeTest) )
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createCommentVNode(" BUTTON MODIFY "),
              _createVNode(_component_base_button, {
                "btn-class": "btn-transparent position-absolute text-w-primary top-0 end-0",
                onClick: _ctx.openDropDown
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: _ctx.labels.genericEdit
                  }, null, 8 /* PROPS */, _hoisted_26)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : (_ctx.listing)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                _createCommentVNode(" BUTTON SEARCH  "),
                _createVNode(_component_base_button, {
                  "data-cy": "placebox-search-btn",
                  "btn-class": `z-index-2 btn-transparent position-absolute text-w-primary top-0 end-0 ${_ctx.spinnerIcon ? 'p-0' : ''}` ,
                  "is-loading": _ctx.spinnerIcon,
                  onClick: _ctx.confirmPlace
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: _ctx.labels.genericSearch
                    }, null, 8 /* PROPS */, _hoisted_27)
                  ]),
                  spinner: _withCtx(() => [
                    (_ctx.spinnerIcon)
                      ? (_openBlock(), _createBlock(_component_static_spinner, {
                          key: 0,
                          class: "me-10 border-none rounded bg-w-secondary icon-xxl"
                        }))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["btn-class", "is-loading", "onClick"])
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ]))
}